import { getTable } from 'src/utils/common';
import { updateData } from 'src/utils/updateFullDineInTableData'

if (!process.env.SERVER) {
  // websocket 回调列表
  window.__stompConnectCallback = window.__stompConnectCallback || {}
  // FullDineIn 回调列表
  window.__fullDineInOnCallBacks = window.__fullDineInOnCallBacks || {}
  // onbeforeunload 回调列表
  window.__beforeunloadCallBacks = window.__beforeunloadCallBacks || []
  // 全局监听回到列表
  window.__globalListeners = window.__globalListeners || {}
}


export default {
  methods: {
    onBeforeUnload() {
      if (!window.onbeforeunload) {
        window.onbeforeunload = () => {
          window.__beforeunloadCallBacks.forEach((cb) => {
            typeof cb === 'function' && cb()
          })
        }
      }
    },
    retsetFullDineInData() {
      this.$store.dispatch('Menu/setFullDineInTableData', {
        cart: {},
        order: {},
      });
    },
    // 单例连接，防止重复连接，根据path，执行回调列表
    __stompConnect(callback, visibilitychange, callbackKey) {
      const { $stomp } = this;
      const _callbackKey = callbackKey || this.$route.fullPath;
      window.__stompConnectCallback[_callbackKey] = window.__stompConnectCallback[_callbackKey] || [];
      window.__stompConnectCallback[_callbackKey].push(callback)
      if (!$stomp.connected) {
        $stomp.onConnect = async () => {
          console.log(`stomp 连接成功 ${_callbackKey}`);
          const stompConnectCallback = window.__stompConnectCallback[_callbackKey];
          if (Array.isArray(stompConnectCallback)) {
            stompConnectCallback.forEach(cb => {
              typeof cb === 'function' && cb();
            });
            console.log(`stomp onConnect Callbacks length ${stompConnectCallback.length}`);
          }
        };
        $stomp.onStompError = (frame) => {
          console.log(`Broker reported error: ${frame.headers.message}`);
          console.log(`Additional details: ${frame.body}`);
          this.$stomp.activate();
        };
        $stomp.onDisconnect = (frame) => {
          console.log('stomp 手动断开成功', frame);
          this.$stomp.activate();
        }
        document.removeEventListener('visibilitychange', visibilitychange)
        document.addEventListener('visibilitychange', visibilitychange);
        const netWorkDownlink = navigator?.connection?.downlink; // 预估下载速度m/s
        if (navigator.connection && navigator.connection.onchange === null) {
          navigator.connection.onchange = () => {
            // 连接到网
            if (netWorkDownlink === navigator.connection?.downlink || navigator?.connection?.rtt !== 0) {
              console.log('断线重连...');
              $stomp.activate();
            }
          }
        }
      } else {
        callback()
      }
      $stomp.activate();
    },
    __rsetStompConnectCallBacks() {
      window.__stompConnectCallback = {}
    },
    async onFullDineInChange(key, fun, apiParams) {
      let sub = null;
      const { $stomp } = this;
      const fullDineInWebsocketHeaders = {
        ack: 'client',
        table: `${getTable()}-${this.storeInfo.id}`,
      }
      // 定义__fullDineInUpdate更新数据
      window.__fullDineInUpdate = async (e, subscribeKey) => {
        const callback = window.__fullDineInOnCallBacks[this.$route.fullPath];
        if (typeof callback === 'function' && (!subscribeKey || key === subscribeKey)) {
          const { success, data, code } = await updateData(this, subscribeKey || key, apiParams);
          success && callback(data, code);
        }
      }
      if (!window.__fullDineInOnCallBacks[this.$route.fullPath]) {
        this.__stompConnect(() => {
          ((path) => {
            if (sub) {
              sub.unsubscribe();
              sub = null;
            }
            sub = $stomp.subscribe(key, message => {
              console.log(`${key} websocket message`, message);
              let data;
              try {
                data = JSON.parse(message.body.slice(0, -2));
              } catch (e) {
                console.log(`${key} websocket message JSON.parse error`, message);
              } finally {
                if (data && path === this.$route.fullPath) {
                  console.log(`call ${path} ${key}subscribe`);
                  console.log('推动回调__fullDineInUpdate')
                  window.__fullDineInUpdate(this, key)
                }
                message.ack(message?.headers?.['message-id'], message?.headers?.subscription);
              }
            },
              fullDineInWebsocketHeaders
            );
          })(this.$route.fullPath);
        }, () => {
          if (document.visibilityState === 'visible') {
            window.__fullDineInUpdate(this);
          }
        });
        this.onBeforeUnload(() => {
          this.$stomp.deactivate()
        })
      }
      // 多次调用·onFullDineInChange·只会更新回调
      window.__fullDineInOnCallBacks[this.$route.fullPath] = fun;
      window.__fullDineInUpdate(this, key);
    },
    onGlobalSubscribKey(key, fn) {
      let sub = null;
      const fullDineInWebsocketHeaders = { ack: 'client', table: `${getTable()}-${this.storeInfo.id}` }
      this.__stompConnect(() => {
        if (sub) sub.unsubscribe();
        sub = this.$stomp.subscribe(key, message => {
          let data;
          try {
            data = JSON.parse(message.body.slice(0, -2));
            console.log('[[GLOBAL_SUBSCRIBE_DATA]]: ', data);
            const callback = window.__globalListeners[key];
            callback && callback(data);
          } catch (e) {
            console.log(`${key} websocket message JSON.parse error`, message);
          } finally {
            message.ack(message?.headers?.['message-id'], message?.headers?.subscription);
          }
        }, fullDineInWebsocketHeaders)
      }, null);
      window.__globalListeners[key] = fn;
    },
    __rsetFullDineInCallBacks() {
      window.__fullDineInOnCallBacks = {}
    },
  }
};
